module.exports = __webpack_public_path__ + "onelogin.3e672d.svg";